/* ezlo.com — GA4 lead, signup and CTA events (Cadence #8, Phase 1 Ezlo Sense launch, 2026-10-01). How-to: ezlo-web docs/tracking/README.md
   Sends through the gtag in theme.liquid (G-7C0BFNN6T1). Enhanced measurement already sends scroll, outbound clicks and the generic
   form_start / form_submit (those also fire for cart, search and login); this adds the events that mean something:
   - generate_lead  a Shopify contact form went through (the page comes back with ?contact_posted=true)    form_name
   - sign_up        newsletter: Shopify customer form (?customer_posted=true) or a Klaviyo form            method, form_name
   - cta_click      a button-styled link, in the page or the menu (not cart drawer, product form, cart)   link_text, link_url, cta_location
   - data-ga-event="event_name" on any element sends that event on click, its other data-ga-* attributes as parameters
     (not data-track: the Academy page uses that for its own cards); data-ga-form="name" on a form overrides its form_name
   - ezloTrack.lead(form, params) / ezloTrack.signup(method, form, params) for forms that send without a reload
   Listeners only: nothing on the page is prevented or changed. */
(function () {
  if (window.ezloTrack || window.top !== window.self) return; // once per page; not inside the hidden iframes some forms post into
  var KEY = 'ezloTrackForm';
  var store = (function () { try { sessionStorage.setItem(KEY + '?', '1'); sessionStorage.removeItem(KEY + '?'); return sessionStorage; } catch (e) { return null; } })();

  function send(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
  }
  function clip(s, n) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().slice(0, n); }
  function merge(a, b) { for (var k in b) if (Object.prototype.hasOwnProperty.call(b, k)) a[k] = b[k]; return a; }
  // "<section key> / <inner section>": one-section pages (Sense, Academy, Deals) need the inner part, e.g. "main / pricing"
  function sectionOf(el) {
    var sec = el.closest('[id^="shopify-section"]');
    if (!sec) return el.closest('.ez-nav-portal, .ez-search-portal, .ez-login-portal') ? 'header' : 'page'; // on mobile the menu moves to <body>
    var key = sec.id.replace(/^shopify-section-(?:template--\d+__|sections--\d+__)?/, '');
    var part = el.closest('section');
    part = part && part !== sec && sec.contains(part) ? part.id || (part.getAttribute('class') || '').split(/\s+/)[0] : '';
    return clip(part ? key + ' / ' + part : key, 80);
  }
  // the contact / newsletter form this tab sent (stored on submit, used once); {} when there is no sessionStorage
  function takeSent() {
    if (!store) return {};
    var p = null;
    try { p = JSON.parse(store.getItem(KEY) || 'null'); store.removeItem(KEY); } catch (e) {}
    return p && Date.now() - p.t < 36e5 ? p : null;
  }
  function lead(form, params, sent) {
    sent = sent || takeSent() || {};
    send('generate_lead', merge({ form_name: clip(form || sent.name || 'contact', 80) }, params || {}));
  }
  function signup(method, form, params, sent) {
    sent = sent || takeSent() || {};
    send('sign_up', merge({ method: method || 'newsletter', form_name: clip(form || sent.name || method || 'newsletter', 80) }, params || {}));
  }
  window.ezloTrack = { send: send, lead: lead, signup: signup };

  // 1. remember which contact / newsletter form is sent; Shopify answers with a redirect back to the page
  document.addEventListener('submit', function (e) {
    var f = e.target, type = f && f.querySelector ? (f.querySelector('input[name="form_type"]') || {}).value : '';
    if (!store || (type !== 'contact' && type !== 'customer')) return;
    try { store.setItem(KEY, JSON.stringify({ name: clip(f.getAttribute('data-ga-form') || f.id || sectionOf(f), 80), t: Date.now() })); } catch (x) {}
  }, true);

  // 2. the page came back after a successful post. theme.liquid keeps the original query in __ezloSearch: several
  //    sections clean the URL before this deferred script runs. No stored form = a reload or a shared link, not a new lead.
  var q = typeof window.__ezloSearch === 'string' ? window.__ezloSearch : location.search;
  if (/[?&](contact|customer)_posted=true/.test(q)) {
    var sent = takeSent();
    if (sent) {
      if (/[?&]contact_posted=true/.test(q)) lead('', null, sent);
      else signup('newsletter', '', null, sent);
    }
  }

  // 3. Klaviyo signup forms (popups, embeds)
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail && e.detail.type === 'submit') signup('klaviyo', 'klaviyo_' + clip(e.detail.formId, 20));
  });

  // 4. data-ga-event elements, then button-styled links
  var CTA = /(^|\s)(btn|button)(\s|$|--|-)|[-_]btn(\s|$|--|-)|__cta|(^|\s)cta(\s|$)/;
  function label(el) {
    var img = el.querySelector('img[alt]');
    return clip(el.textContent, 80) || clip(el.getAttribute('aria-label'), 80) || clip(el.getAttribute('title'), 80) || clip(img && img.alt, 80);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest('[data-ga-event]');
    if (el) {
      var p = {};
      for (var i = 0; i < el.attributes.length; i++) {
        var a = el.attributes[i];
        if (a.name.indexOf('data-ga-') === 0 && a.name !== 'data-ga-event') p[a.name.slice(8).replace(/-/g, '_')] = clip(a.value, 100);
      }
      send(clip(el.getAttribute('data-ga-event'), 40).replace(/[^A-Za-z0-9_]/g, '_'), p);
      return;
    }
    el = t.closest('a[href]');
    if (!el || !CTA.test(el.getAttribute('class') || '')) return;
    if (el.closest('.skip-to-content-link, .nav-cart-btn, cart-drawer, .cart-drawer, #CartDrawer, product-form, form[action*="/cart"]')) return;
    send('cta_click', { link_text: label(el), link_url: clip(el.getAttribute('href'), 200), cta_location: sectionOf(el) });
  }, true);
})();
